import * as React from 'react';
import { SVGProps } from 'react';

const SvgThickness = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M29.785 17.315 15.077 9.027l-9.582 5.318 14.852 8.336 9.438-5.366ZM5.495 17.747l14.756 8.192v-3.305L5.495 14.345v3.402ZM29.88 36l-14.66-8.336'
      stroke='#000'
      strokeLinejoin='round'
    />
    <path
      d='M32.555 34.18V12.27l-2.684 1.918v3.067l-9.64 5.367v3.261l9.64-5.123v15.227l2.684-1.808ZM15.137 20.103v7.613V12.49l-9.64 5.258v-3.396l9.64-5.368V5.917'
      stroke='#000'
      strokeLinejoin='round'
    />
    <path
      d='M30.036 17.696v2.414l-9.878 5.719L5.5 17.719v-3.334l9.552-5.377 14.984 8.688Z'
      fill='#FFEFE6'
    />
    <path
      d='m29.867 20.756-9.576 5.159L5.436 17.76v-3.415l9.58-5.3 14.851 8.271-9.576 5.362'
      stroke='#FF4D00'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='m17.904 4.045 14.66 8.288-2.683 1.916-14.708-8.384 2.73-1.82Z'
      fill='#fff'
      stroke='#000'
      strokeLinejoin='round'
    />
    <path
      d='M20.283 25.913v-3.259L5.473 14.42'
      stroke='#FF4D00'
      strokeLinejoin='round'
    />
  </svg>
);

export default SvgThickness;
